export { Divider, DividerOrientation, DividerSpacing } from './Divider'
export type { DividerProps } from './Divider'

